import PropTypes from 'prop-types'
import React from 'react'

class MonthDropdownOptions extends React.Component {
  renderOptions = () => {
    const selectedMonth = this.props.month
    const options = this.props.monthNames.map((month, i) => (
      <button
        className='react-datepicker__month-option'
        key={month}
        ref={month}
        onClick={this.onChange.bind(this, i)}
      >
        {selectedMonth === i
          ? (
            <span className='react-datepicker__month-option--selected'>✓</span>
          )
          : (
            ''
          )}
        {month}
      </button>
    ))

    return options
  }

  onChange = month => {
    this.props.onChange(month)
  }

  handleClickOutside = () => {
    this.props.onCancel()
  }

  render () {
    return (
      <div className='react-datepicker__month-dropdown'>
        {this.renderOptions()}
      </div>
    )
  }
}

MonthDropdownOptions.displayName = 'MonthDropdownOptions'

MonthDropdownOptions.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  month: PropTypes.number.isRequired,
  monthNames: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
}

export default MonthDropdownOptions
